import {
  GetAppDataRequest,
  GetAppDataResponse,
  GetAppInfosRequest,
  GetAppInfosResponse,
  GetAppsOverallDataRequest,
  GetAppsOverallDataResponse,
} from "../proto/brevis_explorer/statistics_pb";
import { BrevisExplorerClient } from "../proto/brevis_explorer/StatisticsServiceClientPb";

const client = new BrevisExplorerClient(
  // `${process.env.REACT_APP_GRPC_SERVER_URL}`,
  "https://explorer-gateway.brevis.network",
  null,
  null
);

export const getAppInfos = (
  reqParams: GetAppInfosRequest
): Promise<GetAppInfosResponse> => {
  return client.getAppInfos(reqParams, {
    "Access-Control-Allow-Origin": "*",
  });
};

export const getAppsOverallData = (
  reqParams: GetAppsOverallDataRequest
): Promise<GetAppsOverallDataResponse> => {
  return client.getAppsOverallData(reqParams, {
    "Access-Control-Allow-Origin": "*",
  });
};

export const getProofsNum = (
  reqParams: GetAppDataRequest
): Promise<GetAppDataResponse> => {
  return client.getProofsNumByAppName(reqParams, {
    "Access-Control-Allow-Origin": "*",
  });
};

export const getAppRequestNum = (
  reqParams: GetAppDataRequest
): Promise<GetAppDataResponse> => {
  return client.getAppRequestNumByAppName(reqParams, {
    "Access-Control-Allow-Origin": "*",
  });
};

export const getAddressNum = (
  reqParams: GetAppDataRequest
): Promise<GetAppDataResponse> => {
  return client.getUniqAddress(reqParams, {
    "Access-Control-Allow-Origin": "*",
  });
};
